import { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import Overlay from '../../../Componentes/Overlay';
import SideMenu from '../../../Componentes/SideMenu';
import SideMenuBtn from '../../../Componentes/SideMenuBtn';
import Tabela from '../../../Componentes/Utils/Tabela';
import { useModal } from '../../../contexts/ModalContext';
import ModalAddChecklist from './ModalAddChecklist';
import ModalChecklistTipos from './ModalChecklistTipos';
import axios from 'axios';
import styled, { keyframes } from 'styled-components';

import { formatarData } from "../../../Funcoes/FormatarData"
import { useNavigate } from 'react-router-dom';
import GenericHeader from '../../../Componentes/GenericHeader';
import Filters from '../../../Componentes/Utils/Filters';
import FilterContainer from '../../../Componentes/Utils/FilterContainer';
import Stats from '../../../Componentes/Utils/Stats';
import { VerifyPermission } from '../../../Funcoes/VerifyPermission';
import { AuthContext } from '../../../Auth/AuthProvider';
import { VscFilePdf } from "react-icons/vsc";
import { LuLoaderCircle } from "react-icons/lu";
import { saveAs } from 'file-saver';

const spin = keyframes`
    from{ transform: rotate( 0deg ) }
    to{ transform: rotate( 360deg ) }
`
const IconeContainer = styled.div`
    width: 40px;
    height: 35px;
    display: flex;
    align-items: center;
    justify-content: center;
`
const IconePDF = styled(VscFilePdf)`
    margin: auto;
    cursor: pointer;
`
const IconeLoad = styled(LuLoaderCircle)`
    margin: auto;
    animation: ${spin} 1s linear infinite;
`
const TableCell = styled.td`
    text-align: ${(props) => {
        if (props.align === "left") return "left !important";
        if (props.align === "center") return "center !important";
        if (props.align === "right") return "right !important";
        return "left !important";
    }};
    color: ${(props) => {
        if (props.percent !== undefined) {
            if (props.percent >= 75) return "#1f8500 !important";
            if (props.percent >= 50) return "#bb6c05 !important";
            if (props.percent <= 49) return "#bb0505 !important";
        }
        return "#000 !important";
    }};
`;
const ContainerId = styled.div`
    width: 60px;
    height: 35px;
    margin: auto;
    display: flex;
    align-items: center;
    justify-content: center;
`
const ContainerStats = styled.div`
    margin: auto;
    text-align: center;
    display: flex;
    flex-direction: column;
    gap: 3px;
    p{
        margin: 0;
    }
`

const Content = () => {

    const { user } = useContext(AuthContext);

    const { openModal, closeModal, isModalOpen } = useModal();
    const navigate = useNavigate();

    const closeSideBar = () => {

        closeModal();

    }

    const openNewChecklist = () => {

        closeModal();
        openModal("addChecklistModal");

    }

    const openChecklistTipos = () => {
        closeModal();
        openModal('tiposCheckListModal')
    }

    const openMetas = () => {
        closeModal();
        navigate('./metas');
    }

    const openNaoConformidades = () => {
        closeModal();
        navigate('./nao-conformidades')
    }

    const [loading, setLoading] = useState(true);
    const [checklists, setChecklists] = useState([]);
    const [checklistsFilter, setChecklistsFilter] = useState([]);

    const fetchChecklist = async () => {

        setLoading(true);

        try {

            const { data } = await axios.get("https://sistemaintegrado.palmont.com.br/Painel/API/Checklist/GetChecklists/", { withCredentials: true });
            console.log(data);
            setChecklists(data);
            setChecklistsFilter(data);

        } catch (e) {

            console.error(e);

        } finally {

            setLoading(false);

        }

    }

    useEffect(() => {
        fetchChecklist();
    }, [])

    const listaTipos = useMemo(() => [...new Set(checklists.map((obj) => obj.tipo))].sort(), [checklists]);
    const listaModelos = useMemo(() => [...new Set(checklists.map((obj) => obj.modelo))].sort(), [checklists]);
    const listaEquipamentos = useMemo(() => [...new Set(checklists.map((obj) => obj.equipamento))].sort(), [checklists]);
    const listaCC = useMemo(() => [...new Set(checklists.map((obj) => obj.centro_custo))].sort(), [checklists]);
    const listaContrato = useMemo(() => [...new Set(checklists.map((obj) => obj.contrato))].sort(), [checklists]);
    const listaEquipes = useMemo(() => [...new Set(checklists.map((obj) => obj.equipe))].sort(), [checklists]);
    const listaUsuarios = useMemo(() => [...new Set(checklists.map((obj) => obj.usuario))].sort(), [checklists]);

    const [tipoFiltered, setTipoFiltered] = useState([]);
    const [modeloFiltered, setModeloFiltered] = useState([]);
    const [equipamentoFiltered, setEquipamentoFiltered] = useState([]);
    const [centroCustoFiltered, setCentroCustoFiltered] = useState([]);
    const [contratoFiltered, setContratoFiltered] = useState([]);
    const [equipeFiltered, setEquipeFiltered] = useState([]);
    const [statusFiltered, setStatusFiltered] = useState([]);
    const [usuarioFiltered, setUsuarioFiltered] = useState([]);
    const [dataInicial, setDataInicial] = useState('');
    const [dataFinal, setDataFinal] = useState('');

    const handleFilter = useCallback(() => {
        setChecklistsFilter(
            checklists.filter((item) => {
                const tipo = !tipoFiltered.length || tipoFiltered.some(obj => (item.tipo || '').includes(obj.value));
                const modelo = !modeloFiltered.length || modeloFiltered.some(obj => (item.modelo || '').includes(obj.value));
                const equipamento = !equipamentoFiltered.length || equipamentoFiltered.some(obj => (item.equipamento || '').includes(obj.value));
                const obra = !centroCustoFiltered.length || centroCustoFiltered.some(obj => (item.centro_custo || '').includes(obj.value));
                const contrato = !contratoFiltered.length || contratoFiltered.some(obj => (item.contrato || '').includes(obj.value));
                const equipe = !equipeFiltered.length || equipeFiltered.some(obj => (item.equipe || '').includes(obj.value));

                const statusValue = item.qtd_preenchidos < item.qtd_itens
                    ? "EM ANDAMENTO"
                    : "FINALIZADO"

                const status = !statusFiltered.length
                    || statusFiltered.some(obj => statusValue.includes(obj.value));

                const usuario = !usuarioFiltered.length || usuarioFiltered.some(obj => (item.usuario || '').includes(obj.value));
                const dataIniOk = !dataInicial || (item.data && new Date(item.data) >= new Date(dataInicial));
                const dataFimOk = !dataFinal || (item.data && new Date(item.data) <= new Date(dataFinal));

                return tipo && modelo && equipamento && obra && contrato && equipe && status && usuario && dataIniOk && dataFimOk;
            })
        )
    }, [checklists, tipoFiltered, modeloFiltered, equipamentoFiltered, centroCustoFiltered, contratoFiltered, equipeFiltered, statusFiltered, usuarioFiltered, dataInicial, dataFinal]);

    useEffect(() => {

        handleFilter();

    }, [handleFilter]);

    const somaPreenchidos = checklistsFilter.reduce((acc, item) => acc + item.qtd_preenchidos, 0) ?? 0;

    const somaTotalItens = checklistsFilter?.reduce((acc, item) => acc + item.qtd_itens, 0) ?? 0;
    const totalConformes = checklistsFilter.reduce((acc, item) => acc + item.qtd_conforme, 0) ?? 0;
    const totalNaoConformes = checklistsFilter.reduce((acc, item) => acc + item.qtd_ncs, 0) ?? 0;

    const totalPercent = somaPreenchidos > 0 ? (totalConformes / somaTotalItens) * 100 : 0;
    const ncPercent = (totalNaoConformes / somaTotalItens) * 100;

    const [loadingIds, setLoadingIds] = useState([]);

    const handleClick = async (id) => {
        setLoadingIds((prev) => [...prev, id]);

        try {

            const { data } = await axios.post(
                'https://sistemaintegrado.palmont.com.br/Painel/API/Checklist/GeneratePdfChecklists/',
                { id: id },
                {
                    responseType: "blob",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    withCredentials: true,
                }
            );

            const pdfBlob = new Blob([data], { type: "application/pdf" });
            saveAs(pdfBlob, `checklist-${id}.pdf`);

        } catch (e) {

            console.error(e);

        } finally {

            setLoadingIds((prev) => prev.filter((loadingId) => loadingId !== id));

        }

    }

    const openMyMetas = () => {

        closeModal();
        navigate('./minhas-metas');

    }

    return (
        <>
            <GenericHeader>
                <Filters columns={5} >
                    <FilterContainer
                        type="select"
                        placeholder="TIPO..."
                        options={listaTipos}
                        optType={'obj'}
                        valor={tipoFiltered}
                        changeFunc={(value) => setTipoFiltered(value)}
                    />
                    <FilterContainer
                        type="select"
                        placeholder="MODELO..."
                        options={listaModelos}
                        optType={'obj'}
                        valor={modeloFiltered}
                        changeFunc={(value) => setModeloFiltered(value)}
                    />
                    <FilterContainer
                        type="select"
                        placeholder="EQUIPAMENTO..."
                        options={listaEquipamentos}
                        optType={'obj'}
                        valor={equipamentoFiltered}
                        changeFunc={(value) => setEquipamentoFiltered(value)}
                    />
                    <FilterContainer
                        type="select"
                        placeholder="CENTRO CUSTO..."
                        options={listaCC}
                        optType={'obj'}
                        valor={centroCustoFiltered}
                        changeFunc={(value) => setCentroCustoFiltered(value)}
                    />
                    <FilterContainer
                        type="select"
                        placeholder="CONTRATO..."
                        options={listaContrato}
                        optType={'obj'}
                        valor={contratoFiltered}
                        changeFunc={(value) => setContratoFiltered(value)}
                    />
                    <FilterContainer
                        type="select"
                        placeholder="EQUIPE..."
                        options={listaEquipes}
                        optType={'obj'}
                        valor={equipeFiltered}
                        changeFunc={(value) => setEquipeFiltered(value)}
                    />
                    <FilterContainer
                        type="select"
                        placeholder="STATUS..."
                        options={[
                            "EM ANDAMENTO",
                            "FINALIZADO"
                        ]}
                        optType={'obj'}
                        valor={statusFiltered}
                        changeFunc={(value) => setStatusFiltered(value)}
                    />
                    <FilterContainer
                        type="select"
                        placeholder="USUÁRIO..."
                        options={listaUsuarios}
                        optType={'obj'}
                        valor={usuarioFiltered}
                        changeFunc={(value) => setUsuarioFiltered(value)}
                    />
                    <FilterContainer
                        type="date"
                        valor={dataInicial}
                        changeFunc={(value) => setDataInicial(value)}
                    />
                    <FilterContainer
                        type="date"
                        valor={dataFinal}
                        changeFunc={(value) => setDataFinal(value)}
                    />
                </Filters>
                <Stats>
                    <ContainerStats>
                        <p>CONFORMIDADE: {totalPercent.toFixed(2)}%</p>
                        <p>NÃO CONFORMIDADE: {ncPercent.toFixed(2)}%</p>
                        <p>ITENS CONFORMES: {totalConformes}</p>
                        <p>ITENS NÃO CONFORMES: {totalNaoConformes}</p>
                        <p>ITENS PREENCHIDOS: {somaPreenchidos}/{somaTotalItens}</p>
                    </ContainerStats>
                </Stats>
            </GenericHeader>
            <Tabela loading={loading} >
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>TIPO</th>
                        <th>MODELO</th>
                        <th>EQUIPAMENTO</th>
                        <th>DATA</th>
                        <th>CENTRO CUSTO</th>
                        <th>CONTRATO</th>
                        <th>ÁREA</th>
                        <th>AUDITADO</th>
                        <th>LÍDER</th>
                        <th>EQUIPE</th>
                        <th>USUÁRIO</th>
                        <th>PREENCHIDOS</th>
                        <th>CONFORMIDADE</th>
                        <th />
                    </tr>
                </thead>
                <tbody>
                    {checklistsFilter.map((obj) => (
                        <tr
                            key={obj.identifier}
                            onClick={() => navigate(`./${obj.identifier}`)}
                        >
                            <TableCell align='center' >
                                <ContainerId>
                                    {obj.id}
                                </ContainerId>
                            </TableCell>
                            <TableCell>{obj.tipo}</TableCell>
                            <TableCell>{obj.modelo ? obj.modelo : "-"}</TableCell>
                            <TableCell>{obj.equipamento ? obj.equipamento : "-"}</TableCell>
                            <TableCell align="center" >{formatarData(obj.data)}</TableCell>
                            <TableCell>{obj.centro_custo}</TableCell>
                            <TableCell>{obj.contrato}</TableCell>
                            <TableCell>{obj.area}</TableCell>
                            <TableCell>{obj.nome_audit}</TableCell>
                            <TableCell>{obj.lider_nome}</TableCell>
                            <TableCell>{obj.equipe}</TableCell>
                            <TableCell>{obj.usuario}</TableCell>
                            <TableCell align="center" >{`${obj.qtd_preenchidos}/${obj.qtd_itens}`}</TableCell>
                            <TableCell align="center" percent={obj.percent} >{obj.percent.toFixed(2)}%</TableCell>
                            <TableCell align="center">
                                <IconeContainer>
                                    {loadingIds.includes(obj.id)
                                        ? <IconeLoad size={25} />
                                        : <IconePDF size={25} onClick={(e) => {
                                            e.stopPropagation();
                                            handleClick(obj.id);
                                        }} />
                                    }
                                </IconeContainer>
                            </TableCell>
                        </tr>
                    ))}
                </tbody>
            </Tabela>
            {
                isModalOpen('sidebarChecklist') && (
                    <Overlay changeContent={closeSideBar} state={true} >
                        <SideMenu>
                            {VerifyPermission(user, { modulo: 'ssma', submodulo: 'check-list', funcao: 'editar' }) && (
                                <SideMenuBtn
                                    button="CHECKLIST INFO"
                                    clickFunc={openChecklistTipos}
                                />
                            )}
                            {
                                VerifyPermission(user, { modulo: 'ssma', submodulo: 'check-list', funcao: 'metas' }) && (
                                    <SideMenuBtn
                                        button="METAS"
                                        clickFunc={ openMetas }
                                    />
                                )
                            }
                            <SideMenuBtn
                                button="MINHAS METAS"
                                clickFunc={ openMyMetas }
                            />
                            {VerifyPermission(user, { modulo: 'ssma', submodulo: 'check-list', funcao: 'view-nc' }) && (
                                <SideMenuBtn
                                    button="NÃO CONFORMIDADES"
                                    clickFunc={openNaoConformidades}
                                />
                            )}
                            <SideMenuBtn
                                button="NOVO CHECKLIST"
                                clickFunc={openNewChecklist}
                            />
                        </SideMenu>
                    </Overlay>
                )
            }
            {
                isModalOpen('addChecklistModal') && (
                    <ModalAddChecklist
                        fetchSuccess={fetchChecklist}
                    />
                )
            }
            {
                isModalOpen('tiposCheckListModal') && (
                    <ModalChecklistTipos />
                )
            }
        </>
    )
}

export default Content;